import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Security } from '@okta/okta-react';
import { OktaAuth } from '@okta/okta-auth-js';
import App from './App';

const oktaConfig = {
  issuer: 'https://integrator-7517520.okta.com/oauth2/default',
  clientId: '0oatit32uwUY7Yg2a697',
  redirectUri: window.location.origin + '/authorization-code/callback',
  scopes: ['openid', 'profile', 'email'],
  responseType: 'code',
  pkce: true
};

console.log('Okta Config:', oktaConfig);
console.log('Current URL:', window.location.href);

const oktaAuth = new OktaAuth(oktaConfig);

const restoreOriginalUri = async (_oktaAuth, originalUri) => {
  console.log('Restoring original URI:', originalUri);
  window.location.replace(originalUri || '/');
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      <App />
    </Security>
  </BrowserRouter>
);

